var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12"},[_c('h3',{},[_vm._v("Chekout")])])])
}]

export { render, staticRenderFns }